<template>
  <div class="header">
    <div class="header-inner">
      <div class="header__logo">
        <img src="../assets/images/icons/logo.svg" class="header__logo-img" />
      </div>

      <ul class="header__listIcons">
        <li class="header__itemIcons">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20 11.9764C18.1848 11.9764 16.7914 12.6608 15.8664 13.8132C14.9584 14.9445 14.5526 16.4617 14.5518 18.063L14.5138 20.7174L13.0505 23.4356C12.6381 24.2018 13.193 25.1307 14.0631 25.1307H16.8356C16.8442 25.1956 16.8558 25.2701 16.8714 25.352C16.9246 25.631 17.0269 26.0122 17.2268 26.4008C17.4276 26.7913 17.7342 27.2029 18.1994 27.516C18.6696 27.8325 19.2656 28.0236 20.0003 28.0236C20.735 28.0236 21.3309 27.8325 21.8012 27.516C22.2663 27.2028 22.5729 26.7913 22.7738 26.4008C22.9736 26.0121 23.076 25.631 23.1291 25.3519C23.1447 25.2701 23.1563 25.1956 23.165 25.1307H25.9369C26.807 25.1307 27.362 24.2018 26.9495 23.4356L25.4862 20.7174L25.4482 18.063C25.4474 16.4617 25.0416 14.9445 24.1336 13.8132C23.2086 12.6608 21.8152 11.9764 20 11.9764ZM21.8478 25.1307H20H18.1528C18.1913 25.3247 18.2608 25.5689 18.3828 25.8062C18.5086 26.0508 18.6828 26.2743 18.9253 26.4375C19.1627 26.5973 19.5012 26.7236 20.0003 26.7236C20.4994 26.7236 20.8379 26.5973 21.0753 26.4375C21.3177 26.2743 21.4919 26.0508 21.6177 25.8062C21.7398 25.5689 21.8092 25.3247 21.8478 25.1307ZM15.8518 18.0677C15.8518 16.6656 16.2084 15.464 16.8803 14.627C17.536 13.81 18.5417 13.2764 20 13.2764C21.4583 13.2764 22.464 13.81 23.1198 14.627C23.7916 15.464 24.1482 16.6655 24.1482 18.0677H24.1481L24.1483 18.077L24.1886 20.8949C24.1901 20.9992 24.2167 21.1017 24.2662 21.1937L25.6858 23.8307H20H14.3142L15.7338 21.1937C15.7833 21.1017 15.8099 20.9992 15.8114 20.8949L15.8517 18.077L15.8518 18.077V18.0677Z"
              fill="#777C9A"
            />
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              stroke="#E1E3ED"
            />
          </svg>
          <HoverTooltip :text="'Уведомления'" />
        </li>
        <li class="header__itemIcons">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.3668 14.4929C15.8608 12.9989 17.8872 12.1596 20 12.1596C22.1129 12.1596 24.1392 12.9989 25.6333 14.4929C27.1273 15.987 27.9666 18.0133 27.9666 20.1262V23.9106C27.9666 23.9133 27.9666 23.916 27.9666 23.9186V24.4657C27.9666 25.3607 27.611 26.2191 26.9781 26.852C26.3452 27.4849 25.4868 27.8405 24.5918 27.8405C23.9376 27.8405 23.3102 27.5806 22.8477 27.118C22.3851 26.6555 22.1252 26.0281 22.1252 25.3739V22.4473C22.1252 21.7931 22.3851 21.1658 22.8477 20.7032C23.3102 20.2406 23.9376 19.9808 24.5918 19.9808C25.3474 19.9808 26.0769 20.2342 26.6666 20.6939V20.1262C26.6666 18.3581 25.9642 16.6624 24.714 15.4122C23.4638 14.1619 21.7681 13.4596 20 13.4596C18.2319 13.4596 16.5363 14.1619 15.286 15.4122C14.0358 16.6624 13.3334 18.3581 13.3334 20.1262V20.6939C13.9232 20.2341 14.6527 19.9808 15.4082 19.9808C16.0624 19.9808 16.6898 20.2406 17.1523 20.7032C17.6149 21.1658 17.8748 21.7931 17.8748 22.4473V25.3739C17.8748 26.0281 17.6149 26.6555 17.1523 27.118C16.6898 27.5806 16.0624 27.8405 15.4082 27.8405C14.5132 27.8405 13.6548 27.4849 13.0219 26.852C12.389 26.2191 12.0334 25.3607 12.0334 24.4657V23.9106V23.3556V20.1262C12.0334 18.0133 12.8728 15.987 14.3668 14.4929ZM13.3334 23.9106V23.3556C13.3334 22.8053 13.552 22.2776 13.9411 21.8885C14.3302 21.4994 14.858 21.2808 15.4082 21.2808C15.7176 21.2808 16.0143 21.4037 16.2331 21.6224C16.4519 21.8412 16.5748 22.1379 16.5748 22.4473V25.3739C16.5748 25.6833 16.4519 25.98 16.2331 26.1988C16.0143 26.4176 15.7176 26.5405 15.4082 26.5405C14.858 26.5405 14.3302 26.3219 13.9411 25.9328C13.552 25.5437 13.3334 25.0159 13.3334 24.4657V23.9106ZM23.7669 21.6224C23.9857 21.4037 24.2824 21.2808 24.5918 21.2808C25.142 21.2808 25.6698 21.4994 26.0589 21.8885C26.448 22.2776 26.6666 22.8053 26.6666 23.3556V24.4657C26.6666 25.0159 26.448 25.5437 26.0589 25.9328C25.6698 26.3219 25.142 26.5405 24.5918 26.5405C24.2824 26.5405 23.9857 26.4176 23.7669 26.1988C23.5481 25.98 23.4252 25.6833 23.4252 25.3739V22.4473C23.4252 22.1379 23.5481 21.8412 23.7669 21.6224Z"
              fill="#777C9A"
            />
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              stroke="#E1E3ED"
            />
          </svg>
          <HoverTooltip :text="'Тех. поддержка'" />
        </li>
        <li class="header__itemIcons" @click="logoutUser">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              fill="white"
            />
            <g clip-path="url(#clip0_377_3752)">
              <path
                d="M23.3571 25.7042V26.2857C23.3571 26.5888 23.2367 26.8795 23.0224 27.0938C22.8081 27.3082 22.5174 27.4286 22.2143 27.4286H14.2143C13.9112 27.4286 13.6205 27.3082 13.4061 27.0938C13.1918 26.8795 13.0714 26.5888 13.0714 26.2857V13.7143C13.0714 13.4112 13.1918 13.1205 13.4061 12.9062C13.6205 12.6918 13.9112 12.5714 14.2143 12.5714H22.2143C22.5174 12.5714 22.8081 12.6918 23.0224 12.9062C23.2367 13.1205 23.3571 13.4112 23.3571 13.7143V14.5"
                stroke="#777C9A"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22 20L27 20"
                stroke="#777C9A"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M25.0714 17.7143L27.3571 20L25.0714 22.2857"
                stroke="#777C9A"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <rect
              x="0.5"
              y="0.5"
              width="39"
              height="39"
              rx="7.5"
              stroke="#E1E3ED"
            />
            <defs>
              <clipPath id="clip0_377_3752">
                <rect
                  width="17"
                  height="17"
                  fill="white"
                  transform="translate(11.5 11.5)"
                />
              </clipPath>
            </defs>
          </svg>
          <HoverTooltip :text="'Выход'" />
        </li>
        <li class="header__itemIcons">
          <div class="avatar" v-if="userInfo?.avatarUrl">
            <img :src="userInfo.avatarUrl" alt="avatar__logo" />
          </div>
          <div class="avatar" v-else>
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="35" height="35" fill="#e60000" />
              <rect
                opacity="0.24"
                width="35"
                height="35"
                fill="url(#paint0_linear_377_3759)"
              />
              <path
                d="M15.4932 21H14.3311V14.999H12.6318C12.3942 16.6885 12.207 17.8831 12.0703 18.583C11.9336 19.2796 11.7952 19.7939 11.6553 20.126C11.5153 20.4548 11.3249 20.7005 11.084 20.8633C10.8431 21.0228 10.555 21.1025 10.2197 21.1025C9.93327 21.1025 9.68424 21.0651 9.47266 20.9902V19.999C9.62891 20.0804 9.80306 20.1211 9.99512 20.1211C10.1937 20.1211 10.3792 20.0055 10.5518 19.7744C10.7243 19.5433 10.9001 18.9427 11.0791 17.9727C11.2614 16.9993 11.4616 15.6745 11.6797 13.998H15.4932V21ZM24.7559 21H23.6035V16.4688C23.6035 16.0977 23.6263 15.6436 23.6719 15.1064H23.6523C23.5807 15.4124 23.5173 15.6322 23.4619 15.7656L21.3721 21H20.5713L18.4766 15.8047C18.418 15.6517 18.3561 15.4189 18.291 15.1064H18.2715C18.2975 15.3864 18.3105 15.8438 18.3105 16.4785V21H17.2363V13.998H18.8721L20.7129 18.6611C20.8529 19.0192 20.944 19.2861 20.9863 19.4619H21.0107C21.1312 19.0941 21.2288 18.8206 21.3037 18.6416L23.1787 13.998H24.7559V21Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_377_3759"
                  x1="17.5"
                  y1="0"
                  x2="17.5"
                  y2="35"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <UserHoverTooltip v-if="userInfo" :userInfo="userInfo" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import HoverTooltip from "@/components/UI/HoverTooltip.vue";
import UserHoverTooltip from "@/components/UI/UserHoverTooltip.vue";
import { computed } from "vue";
export default {
  components: { HoverTooltip, UserHoverTooltip },
  setup() {
    const store = useStore();
    const userInfo = computed(() => store.state.mainData.userInfo);
    const logoutUser = () => {
      store.dispatch("logoutUser", store.state.UseApi.params);
    };
    return {
      userInfo,
      logoutUser,
    };
  },
};
</script>
<style lang="scss" src="@/assets/styles/header.scss"></style>
